"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENGLISH_LANGUAGE = exports.FRENCH_LANGUAGE = void 0;
exports.FRENCH_LANGUAGE = 'fr';
exports.ENGLISH_LANGUAGE = 'en';
